import { createLazyComponentFromNamedExport } from '@shared/utils/createLazyComponent';
import { ThingsToDoGrabber } from './ThingsToDoSidebar';
import { THINGS_TO_DO_SCHEMA_URL, THINGS_TO_DO_COMPONENT_TYPE } from './ThingsToDo.constants';
import { AdminJsonComponentConfig } from '@apps/websiteCustomJsonComponents/types';

// Lazy load view components
const ThingsToDoAdd = createLazyComponentFromNamedExport(() => import(/* webpackChunkName: "content/websiteEditorThingsToDoAdd" */ './ThingsToDoSidebar'), 'ThingsToDoAdd');

const ThingsToDoEdit = createLazyComponentFromNamedExport(() => import(/* webpackChunkName: "content/websiteEditorThingsToDoEdit" */ './ThingsToDoEdit'), 'ThingsToDoEdit');

// Add this object to CUSTOM_JSON_COMPONENT_TYPES in
// src/apps/websiteCustomJsonComponents/config.ts
export const ThingsToDoConfig: AdminJsonComponentConfig = {
  schemaUrl: THINGS_TO_DO_SCHEMA_URL,
  componentType: THINGS_TO_DO_COMPONENT_TYPE,
  adminSidebarComponent: {
    addComponentView: ThingsToDoAdd,
    dragComponentView: ThingsToDoGrabber,
    editComponentView: ThingsToDoEdit,
    createComponentView: ThingsToDoEdit,
  },
};
